import axios from "axios";
import { liveURL } from "../constants/Consts";

const MAIN_URL = `${liveURL}/v1/adminMunasibaat`;

// Category Requests
export async function getCategories(token) {
  try {
    const response = await axios.get(`${MAIN_URL}/getCategories`, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching categories:", error);
    return { success: false, data: [] };
  }
}

export async function createCategory(token, data) {
  try {
    const response = await axios.post(`${MAIN_URL}/createCategory`, data, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating category:", error);
    return { success: false, errors: [error.response?.data?.errors?.[0] || "Error creating category"] };
  }
}

export async function updateCategory(token, id, data) {
  try {
    const response = await axios.put(`${MAIN_URL}/updateCategory/${id}`, data, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating category:", error);
    return { success: false, errors: [error.response?.data?.errors?.[0] || "Error updating category"] };
  }
}

export async function deleteCategory(token, id) {
  try {
    const response = await axios.delete(`${MAIN_URL}/deleteCategory/${id}`, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting category:", error);
    return { success: false, errors: ["Error deleting category"] };
  }
}

// Entry Requests
export async function getEntries(token, categoryId) {
  try {
    const url = categoryId ? `${MAIN_URL}/getEntries?category_id=${categoryId}` : `${MAIN_URL}/getEntries`;
    const response = await axios.get(url, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching entries:", error);
    return { success: false, Entries: [] };
  }
}

export async function getEntryById(token, id) {
  try {
    const response = await axios.get(`${MAIN_URL}/getEntry/${id}`, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching entry by ID:", error);
    return { success: false };
  }
}

export async function createEntry(token, data) {
  try {
    const response = await axios.post(`${MAIN_URL}/createEntry`, data, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error creating entry:", error);
    return { success: false, errors: [error.response?.data?.errors?.[0] || "Error creating entry"] };
  }
}

export async function updateEntry(token, id, data) {
  try {
    const response = await axios.put(`${MAIN_URL}/updateEntry/${id}`, data, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating entry:", error);
    return { success: false, errors: [error.response?.data?.errors?.[0] || "Error updating entry"] };
  }
}

export async function deleteEntry(token, id) {
  try {
    const response = await axios.delete(`${MAIN_URL}/deleteEntry/${id}`, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting entry:", error);
    return { success: false, errors: ["Error deleting entry"] };
  }
}

// Helper Selectors
export async function getMujjalahList(token) {
  try {
    const response = await axios.get(`${MAIN_URL}/helpers/mujjalahList`, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching mujjalah list:", error);
    return { success: false, data: [] };
  }
}

export async function getNoorDiaryList(token) {
  try {
    const response = await axios.get(`${MAIN_URL}/helpers/noorDiaryList`, {
      headers: { token },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching noor diary list:", error);
    return { success: false, data: [] };
  }
}

// Backward Compatibility Aliases
export async function createMunasibaat(token, data) {
  return createEntry(token, data);
}
export async function getMunasibaat(token) {
  return getEntries(token);
}
export async function getMunasibaatById(token, id) {
  return getEntryById(token, id);
}
export async function updateMunasibaat(token, id, data) {
  return updateEntry(token, id, data);
}
export async function deleteMunasibaat(token, id) {
  return deleteEntry(token, id);
}